import { render } from "./SettingIcon.vue?vue&type=template&id=7ffac332&ts=true"
import script from "./SettingIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/SettingIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ffac332"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ffac332', __exports__)) {
    api.reload('7ffac332', __exports__)
  }
  
  module.hot.accept("./SettingIcon.vue?vue&type=template&id=7ffac332&ts=true", () => {
    api.rerender('7ffac332', render)
  })

}


export default __exports__